import { StyleSheet } from 'react-native';
import { ThemeColors } from '@/src/context/ThemeContext';

export const createStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    container: {
      flex: 1,
    },
    header: {
      padding: 20,
      backgroundColor: colors.surface,
      borderBottomWidth: 1,
      borderBottomColor: colors.border,
    },
    createButton: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: colors.primary,
      borderRadius: 10,
      padding: 14,
      gap: 8,
    },
    createButtonText: {
      color: colors.primaryText,
      fontSize: 16,
      fontWeight: '600',
    },
    list: {
      padding: 16,
    },
    card: {
      borderRadius: 12,
      borderWidth: 1,
      padding: 14,
      marginBottom: 12,
      flexDirection: 'row',
      alignItems: 'center',
    },
    logoCircle: {
      width: 48,
      height: 48,
      borderRadius: 24,
      borderWidth: 1,
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: 12,
    },
    logoImage: {
      width: 48,
      height: 48,
      borderRadius: 24,
    },
    cardInfo: {
      flex: 1,
    },
    teamName: {
      fontSize: 16,
      fontWeight: '700',
      marginBottom: 3,
    },
    teamMeta: {
      fontSize: 12,
    },
    captainBadge: {
      paddingHorizontal: 8,
      paddingVertical: 3,
      borderRadius: 6,
      marginTop: 4,
      alignSelf: 'flex-start',
    },
    captainBadgeText: {
      fontSize: 11,
      fontWeight: '600',
    },
    chevron: {
      marginLeft: 8,
    },
    emptyContainer: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      padding: 40,
    },
    emptyTitle: {
      fontSize: 18,
      fontWeight: '700',
      marginTop: 16,
      marginBottom: 8,
      textAlign: 'center',
    },
    emptySubtitle: {
      fontSize: 14,
      textAlign: 'center',
    },
  });
